import { render, staticRenderFns } from "./SendSolutionThanksBanner.vue?vue&type=template&id=04c82cc1&scoped=true&"
import script from "./SendSolutionThanksBanner.vue?vue&type=script&lang=ts&"
export * from "./SendSolutionThanksBanner.vue?vue&type=script&lang=ts&"
import style0 from "./SendSolutionThanksBanner.vue?vue&type=style&index=0&id=04c82cc1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c82cc1",
  null
  
)

export default component.exports